<template>
    <component :is="questionComponent" v-bind="{...$props, ...$attrs}" v-on="$listeners"/>
</template>

<script>
import HeadingQuestion from "@/components/pages/registration/questions/questionTypes/HeadingQuestion";
import TextQuestion from "@/components/pages/registration/questions/questionTypes/TextQuestion";
import QuestionQuestion from "@/components/pages/registration/questions/questionTypes/QuestionQuestion";
import questionTypes from "@/util/consts/questionTypes";

export default {
    name: "QuestionDecorator",
    components: {
        HeadingQuestion, TextQuestion, QuestionQuestion
    },
    props: {
        question: {
            type: Object,
            required: true
        }
    },
    computed: {
        questionComponent() {
            switch (this.question.questionType) {
                case questionTypes.TYPE_QUESTION:
                    return "QuestionQuestion"
                case questionTypes.TYPE_HEADING:
                    return "HeadingQuestion"
                case questionTypes.TYPE_PLACEHOLDER:
                    return null
                case questionTypes.TYPE_TEXT:
                    return "TextQuestion"
                case questionTypes.TYPE_QUANTITY:
                    return "QuestionQuestion"
                case questionTypes.TYPE_DATE:
                    return "QuestionQuestion"
                case questionTypes.TYPE_CERTIFICATE:
                    return "QuestionQuestion"
                default:
                    return null
            }
        }
    }
}
</script>

<style scoped>

</style>
